import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'

import { Typography, Button, Box, useTheme, styled } from '@mui/material'
//import { mainStyles } from '../../styles/Main.js'
import { useStyles } from './SelectProductStyle.js'
import { workflowActions, fileActions } from '../../store/actions'
import { GenericButtonList, CustomLoadingOverlay, GenericContainer,GenericStatusElement } from '../../components'
import { getReplaceTitle, coreFunctions } from '../../utils'
import { useTranslation } from 'react-i18next'

export default function SelectProductComponent(props) {
    const theme = useTheme()
    const location = useLocation()
    const localStyles = useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [products, setProducts] = useState([])
    const [productId, setProductId] = useState(0)

    const flowsOptions = useSelector(state => state.Workflow)
    const folioInfo = useSelector(state => state.FolioInfo)
    const { t } = useTranslation();

    const requestFlows = {
        Workflow_Id: null,
        Workflow_Version: null,
        Apk_Version: "1.1.3",
        IMEI: "PWA"
    }

    useEffect(() => {
        setLoadView(true)
        dispatch(workflowActions.GetWorkflowDefinitions(requestFlows))
        getReplaceTitle("Onboarding")
    }, [])

    useEffect(() => {
        console.log("flowsOptions.items: ", loadView, flowsOptions.items)
        if (flowsOptions.items != undefined && loadView) {
            if (flowsOptions.items?.length > 0) {
                if (flowsOptions.items.length > 1) {
                    setProducts(flowsOptions.items)
                    setLoadView(false)
                } else if (flowsOptions.items?.length == 1) {
                    let id = flowsOptions.items[0]?.Id
                    setProductId(id)
                    const body = {
                        ProductId: id,
                        Metadata: null
                    }
                    console.log("Request:  body ", body)
                    dispatch(fileActions.GenerateFolio(body))
                    setLoadView(true)
                } else {
                    console.log("No se econtraron productos configuracos, ", flowsOptions.items)
                }
            }
        }
        else if (flowsOptions.error != undefined && loadView) {
            setLoadView(false)
            alert(flowsOptions.error)
        }
    }, [flowsOptions])

    const selectProduct = (id) => {
        setProductId(id)
        console.log("Producto ID: ", id)
        const body = {
            ProductId: id,
            Metadata: null
        }
        dispatch(fileActions.GenerateFolio(body))
        setLoadView(true)
    }

    useEffect(() => {
        if (folioInfo.items != undefined && loadView) {
            let configs = {
                "FileId": folioInfo.items?.Result?.Id,
                "OcrOnline": false,
                "CaptureSelfieSdk": (sessionStorage.getItem('TypeCaptureSelfieSdk') != undefined && sessionStorage.getItem('TypeCaptureSelfieSdk') != null || sessionStorage.getItem('TypeCaptureSelfieSdk') != "" ? sessionStorage.getItem('TypeCaptureSelfieSdk') : "FaceTec3D"),
                "SkipDocumentValidation": (sessionStorage.getItem('omitirValidacion') != undefined && sessionStorage.getItem('omitirValidacion') != null && sessionStorage.getItem('omitirValidacion') != "" ? Boolean(sessionStorage.getItem('omitirValidacion')) : false),
                "RiskLevel": (sessionStorage.getItem('nivelRiesgo') != undefined && sessionStorage.getItem('nivelRiesgo') != null || sessionStorage.getItem('nivelRiesgo') != "" ? sessionStorage.getItem('nivelRiesgo') : "Alto")
            }

            console.log("----Configuraciones----Ejecutadas----Values-------------: ", configs)
            dispatch(fileActions.SetManualConfigurations(configs))

            console.log("folioInfo.items---------------: ", folioInfo.items)
            console.log("folioInfo.items-------Stage-----------------: ", folioInfo.items.Stage)
            const stage = folioInfo.items.Stage
            const stageName = folioInfo.items.Stage.Name
            const stageId = folioInfo.items.Stage.Id
            const folioId = folioInfo.items.Result.Id

            console.log(" folioInfo.items.Product ", folioInfo.items.Product)
            // const nextComponent = productId === 19 ? 'SearchGroupComponent' :
            const nextComponent = folioInfo.items?.Result?.Product == "Solicitud Grupal" ? 'SearchGroupComponent' :
                folioInfo.items?.Result?.Product == "Cobranza" ? coreFunctions.GetLegoNext("GestionCobranzaHelp") : coreFunctions.GetLegoNext(stageName)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stage, stageName, stageId, folioId } })
        }
    }, [folioInfo])

    return (<GenericContainer>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <Typography variant='h6'>Tipo de producto</Typography>
        <Typography variant='subtitle1'>Selecciona el tipo de opción que más te interese.</Typography>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            {products.map((product, index) => {
                console.log(product)
                return <GenericButtonList
                    key={`${index}`}
                    onClick={() => {
                        selectProduct(product.Id)
                    }}
                >
                    <GenericStatusElement
                        key={`${index}_${product.Name}`}
                        icon={product.Icon}
                        text={product.Name} />
                </GenericButtonList>
            })}
        </Box>
    </GenericContainer>)
}